var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',{attrs:{"disabled":_vm.disabled,"value":_vm.value},on:{"change":function (value) { return _vm.$emit('update', value); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }